import { request, history } from 'ice';
import { Message } from '@b-design/fusion';
import $i18n from '../i18n';
import { queryPathName } from '@/utils/url-parse';

/**
 * GET请求
 * @param url 请求url
 * @param params 请求参数
 * @param options 请求配置项
 * @returns res 请求结果
 */
async function RequestGet(url: string, params?: any, options: any = {}) {
  const locale = $i18n.language || 'en-US';
  // const locale = 'en-US';

  try {
    const getRequestConfig = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'x-locale': locale },
      params,
      responseType: 'blob',
      ...options,
    };
    const res = (await request.get(url, getRequestConfig)) || {};
    if (res.errorCode) {
      errorHandler(res);
    }
    
    return res;
  } catch (error) {
    errorHandler(error?.response?.data || error);
  }
}

/**
 * POST请求
 * @param url 请求url
 * @param params 请求参数
 * @param options 请求配置项
 * @returns res 请求结果
 */
async function RequestPost(url: string, data?: any, options: any = {}) {
  try {
    const postRequestConfig = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      ...options,
    };
    const res = (await request.post(url, data, postRequestConfig)) || {};
    if (res.errorCode) {
      errorHandler(res);
    }
    return res;
  } catch (error) {
    errorHandler(error?.response?.data || error);
  }
}

/**
 * GET请求 直接返回res
 * @param url 请求url
 * @param params 请求参数
 * @param options 请求配置项
 * @returns res 请求结果
 */
async function RequestDown(url: string, params?: any, options: any = {}) {
  const locale = $i18n.language || 'en-US';
  // const locale = 'en-US';

  try {
    const getRequestConfig = {
      headers: { 'Content-Type': 'application/json', 'x-locale': locale },
      params,
      ...options,
    };
    const res = (await request.get(url, getRequestConfig)) || {};
    if (res.errorCode) {
      errorHandler(res);
    }
    return res;
  } catch (error) {
    errorHandler(error?.response?.data || error);
  }
}

/**
 * 独立页面，不需要登录态
 */
const independentRoutes = ['/emas/preview', '/login'];

/**
 * 错误处理
 * @param error 报错信息
 * @returns
 */
function errorHandler(error) {
  const { data, errorCode } = error;
  if (errorCode === '401' || errorCode === 401 || (!data?.isDuibaUser && (data?.isAliyunPaymentUser === false && data?.accountSrc === 'aliyun'))) {
    // 报401错误时 从接口获取url 拼好后重定向到login页
    const { href } = window.location;
    let encodeGotoUrl = '';

    if (href.indexOf('redirect') > -1) {
      const str = href.slice(href.indexOf('redirect'));
      encodeGotoUrl = str.slice(str.indexOf('http'));
    } else {
      encodeGotoUrl = encodeURIComponent(href);
    }

    if (!independentRoutes?.includes(queryPathName())) {
      const href = location.href.split('#/')[0];
      window.location.replace(`${href}#/login?redirect=${encodeGotoUrl}`);
      // history?.push(`/login?redirect=${encodeGotoUrl}`);
    }
  } else {
    const message = $i18n.get({
      id: 'aopf.src.services.request.InterfaceRequestError',
      dm: '接口请求错误',
    });
    Message.error(error?.errorMsg || error?.Detail || message);
  }
}

const Requests = {
  get: RequestGet,
  post: RequestPost,
  down:RequestDown,
};

export default Requests;
